import { colors } from '@common';
import { Buildings, Cards, UsersThree } from '@phosphor-icons/react';
import { Space } from 'antd';
import { NavLink } from 'react-router-dom';

interface ClientShortcutsProps {
	customerId: string;
}

const style = {
	itemNav:
		'inline-flex items-center gap-2 text-sm !text-gray-900 hover:!text-gray-700 px-2 py-1 rounded-md border border-gray-200',
	activeItemNav: '!bg-teal-50 !border-teal-200',
};

const ItemNav = ({
	label,
	icon,
	to,
}: {
	label: string;
	icon: React.ReactNode;
	to: string;
}) => (
	<NavLink
		to={to}
		end
		className={({ isActive }) =>
			`${style.itemNav} ${isActive ? style.activeItemNav : ''}`
		}
	>
		{icon}
		{label}
	</NavLink>
);

export const ClientShortcuts = ({ customerId }: ClientShortcutsProps) => {
	const items = [
		{
			label: 'Overview',
			icon: <Cards className='w-6 h-6' color={colors.primary} />,
			to: `/clientes/${customerId}`,
		},
		{
			label: 'Family',
			icon: <UsersThree className='w-6 h-6' color={colors.primary} />,
			to: `/clientes/${customerId}/familia`,
		},
		{
			label: 'Assets',
			icon: <Buildings className='w-6 h-6' color={colors.primary} />,
			to: `/clientes/${customerId}/patrimonio`,
		},
	];
	return (
		<Space className='ml-auto'>
			{items.map((item) => (
				<ItemNav key={item.label} {...item} />
			))}
		</Space>
	);
};
